module.exports = __webpack_public_path__ + "src/assets/images/logo-benji-color.svg?01d9999b0ba6566d63d6ea410cb18e65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-benji-color.svg
// module id = 1014
// module chunks = 1